import { useRef, useState } from "react";
import BiodataPreview from "./BiodataPreview";
import html2canvas from "html2canvas";
import TemplateSelector from "./TemplateSelector";
import jsPDF from "jspdf";

export default function BiodataContainer({
  sections,
  template,
  userImage,
  onTemplateChange,
}) {
  const previewRef = useRef();
  const [imgLoaded, setImgLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const downloadPDF = async () => {
    if (!previewRef.current) return;

    if (!imgLoaded) {
      alert("Please wait until the template image is fully loaded");
      return;
    }

    const pages = previewRef.current.querySelectorAll(".bd-page");
    const pdf = new jsPDF("p", "pt", "a4");

    for (let i = 0; i < pages.length; i++) {
      const canvas = await html2canvas(pages[i], {
        scale: 2,
        useCORS: false,
        allowTaint: false,
        backgroundColor: null,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    }

    pdf.save("biodata.pdf");
  };

  const downloadImage = async () => {
  if (!previewRef.current) return;

  if (!imgLoaded) {
    alert("Please wait until the template image is fully loaded");
    return;
  }

  const pages = previewRef.current.querySelectorAll(".bd-page");

  for (let i = 0; i < pages.length; i++) {
    const canvas = await html2canvas(pages[i], {
      scale: 2,
      useCORS: false,
      allowTaint: false,
      backgroundColor: "#ffffff",
    });

    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = `wd_biodata${i + 1}.png`;

    // 🔥 Required for Firefox & some Chromium versions
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};


  return (
    <div className="preview-outer">
      <div className="preview-scale shadow-sm">
        <div ref={previewRef} className="maincontainer">
          <BiodataPreview
            sections={sections}
            template={template}
            userImage={userImage}
            onImgLoad={() => setImgLoaded(true)}
          />
        </div>
      </div>

   

<div class="bg-white bd_download_sect p-3 mt-3 mb-4 rounded-lg text-center shadow-sm d-flex justify-content-between gap-2 ms-auto ">
        

        <button
          className="btn btn-md btn-outline-primary"
          onClick={() => setShowModal(true)}
        >
          Change Template
        </button>

        <div className="bd_download_b">
        <button className="btn btn-md btn-primary mx-2" onClick={downloadImage}>
          Download Image
        </button>
        <button className="btn btn-md btn-primary" onClick={downloadPDF}>
          Download PDF
        </button>
        </div>
      </div>


      <div class="trust-card shadow-sm">
          <div>🛡️ <strong>No data is stored on server</strong></div>
          <div>⚡ <strong>Biodata is generated instantly</strong></div>
          <div>🔒 <strong>100% private & secure</strong></div>
      </div>

      {showModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Select Biodata Template</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ><span aria-hidden="true">&times;</span></button>
                </div>

                <div className="modal-body">
                  <TemplateSelector
                    selected={template}
                    onSelect={(tpl) => {
                      onTemplateChange(tpl);
                      setShowModal(false);
                      setImgLoaded(false);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
      
    </div>

  );
}
